import React from 'react';
import styled from 'styled-components';
// --------------------------------------------------------------------------------
import { Carousel, CarouselProps } from './Carousel';
import { String } from './String';
import { config, Icons } from '../index';

export interface ListingComponentProps {
  /* Carousel props */
  links?: CarouselProps['links'];
  /* ListingComponent saved */
  saved?: boolean;
  /* ListingComponent title */
  title?: string;
  /* ListingComponent price per day */
  pricePerDay?: number;
  /* ListingComponent price per week */
  pricePerWeek?: number;
  /* ListingComponent price per month */
  pricePerMonth?: number;
  /* ListingComponent distance */
  distance?: number;
  /* ListingComponent rating */
  rating?: number;
  /* ListingComponent total reviews */
  reviews?: number;
  /* ListingComponent backgroundColor */
  backgroundColor?: string;
  /* ListingComponent margin */
  margin?: string;
  /* ListingComponent padding */
  padding?: string;
  /* ListingComponent width */
  width?: string;
  /* ListingComponent height */
  height?: string;
  /* ListingComponent additional class props */
  className?: string;
  /* Carousel onLikeClick handler */
  onLikeClick?: (event?: React.MouseEvent) => void;
}

const StyledListingComponent = styled.div<ListingComponentProps>`
  overflow: hidden;
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  background-color: ${(props) => props.backgroundColor};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
`;

const ContentWrapper = styled.div<ListingComponentProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ListingDetailWrapper = styled.div<ListingComponentProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${config.spacingSmall};
`;

export const ListingComponent: React.FC<ListingComponentProps> = ({
  links,
  saved,
  title,
  pricePerDay = 0,
  pricePerWeek = 0,
  pricePerMonth = 0,
  distance = 0,
  rating = 0,
  reviews = 0,
  margin,
  padding,
  width = '415px',
  height = '355px',
  backgroundColor = config.transparent,
  onLikeClick,
  // additional props
  ...props
}) => {
  return (
    <StyledListingComponent
      backgroundColor={backgroundColor}
      margin={margin}
      padding={padding}
      width={width}
      height={height}
      {...props} // any additional props that override the defaults
    >
      <Carousel
        links={links}
        saved={saved}
        height="275px"
        onLikeClick={onLikeClick}
      />
      <ContentWrapper>
        <String
          string={title}
          limit={1}
          margin="14px 0"
          fontSize="20px"
          fontWeight="bold"
        />
        <ListingDetailWrapper>
          <String
            string={`${pricePerDay}/Day`}
            fontSize="20px"
            color={config.grey}
          />
          <Icons size={8} icon="dot" />
          <String
            string={`${distance}km away`}
            fontSize="20px"
            color={config.grey}
          />
          <Icons size={8} icon="dot" />
          <Icons size={24} icon="star" />
          <String string={`${rating}`} fontSize="20px" color={config.grey} />
          <String string={`(${reviews})`} fontSize="20px" color={config.grey} />
        </ListingDetailWrapper>
      </ContentWrapper>
    </StyledListingComponent>
  );
};
